import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { getLineColor } from "@/helpers/helperFunctions";
import { memo, useState } from "react";
import { MdClose, MdFileCopy } from "react-icons/md";

const InputField = ({ item, onFocus, onBlur, placeholder, id }: any) => {
  const [value, setValue] = useState(item?.value ?? "");
  return (
    <Textarea
      className="nodrag bg-transparent border-none px-0 resize-none"
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
      maxLength={1500}
      onChange={(e: any) => {
        setValue(e.target.value);
        item.value = e.target.value;
      }}
      placeholder={placeholder}
    />
  );
};

export default memo(
  ({
    id,
    data,
    isConnectable,
  }: {
    id: string;
    data: any;
    isConnectable: boolean;
  }) => {
    const onBlur = () => localStorage.setItem("focus", JSON.stringify(false));
    const onFocus = () => localStorage.setItem("focus", JSON.stringify(true));

    return (
      <>
        <Card
          className="max-w-xs w-screen text-black"
          style={{
            boxShadow: `0px 0px 16px 10px ${data.other_inputs[0].color}66`,
            backgroundColor: data.other_inputs[0].color,
          }}
        >
          <div
            className="sticky_header__container"
            style={{
              borderBottom: `1px solid ${getLineColor(data?.type)}`,
            }}
          >
            <CardHeader className="pb-2">
              <CardTitle>
                <div className="flex items-start justify-between items-center=">
                  <div className="text-lg text-black truncate">{data?.title?.replace("/", " / ")}</div>
                  <div className="flex gap-2">
                    <Tooltip>
                      <TooltipTrigger>
                        <Button
                         
                          className="text-black hover:bg-transparent"
                          variant="ghost"
                        //   onClick={() => {
                        //     addNewNode({
                        //       name: data.title,
                        //       type: data.type,
                        //     });
                        //     Alert("Successfully Cloned", "success");
                        //   }}
                        >
                          <MdFileCopy size="icon"/>
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>Clone Block</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger>
                        <Button
                          variant="ghost"
                          className="text-black hover:bg-transparent"
                        //   onClick={() => {
                        //     deleteNode(id);
                        //     Alert("Successfully Deleted", "success");
                        //   }}
                        >
                          <MdClose size={16} />
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>Delete Block</TooltipContent>
                    </Tooltip>
                  </div>
                </div>

              </CardTitle>
            </CardHeader>
            <Separator/>
            
          </div>

          <CardContent >
              <InputField
                item={data.other_inputs[0]}
                onFocus={onFocus}
                onBlur={onBlur}
                placeholder="Enter text..."
                id={data.id}
              />
          </CardContent>
        </Card>
      </>
    );
  }
);
